import isNull from 'lodash/isNull';
import { isSsr } from './ssr';
import { Menu } from '~/types';

export function isObjectValueNull(object) {
  return Object.values(object).every(isNull);
}

export const isClient = (): boolean => {
  return !isSsr();
};

export const filterMenuItems = (items: Menu.MenuItem[], allowed: string[]): Menu.MenuItem[] => {
  return items.filter((item) => {
    if (item.component) {
      return allowed.includes(item.component);
    }
    return false;
  });
};
